import React, { Component } from 'react';
import { MDBBreadcrumb, MDBBreadcrumbItem, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput } from 'mdbreact';


class HeaderShop extends Component {
    constructor(props) {
        super(props);
        this.keyPress = this.keyPress.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    keyPress(e) {
        if (this.props.searchOnEnter == undefined && e.keyCode !== 13) {
            this.props.searchList(e.target.value);
        } else {
            if (this.props.searchOnEnter && e.keyCode == 13) {
                this.props.searchList(e.target.value);
                e.target.value = '';
            }
        }

    }

    onSubmit(e) {
        e.preventDefault();
    }

    render() {
        let hideSearch = this.props.hideSearch === undefined || this.props.hideSearch === null ? false : this.props.hideSearch;
        let subHeaderSize = this.props.subHeaderTextSize === undefined || this.props.subHeaderTextSize === null ? '14px' : this.props.subHeaderTextSize;
        let tester = "";
        return (
            <div>
                <MDBRow>
                    <MDBCol md="6" sm="6">
                        <h2>{this.props.headerText}</h2><span style={{ fontSize: subHeaderSize }}>&nbsp;{this.props.subHeaderText}</span>

                    </MDBCol>
                </MDBRow>
                    
                {!hideSearch ? (
                        <MDBRow>
                        <MDBCol lg="3" md="4" sm="12">
                            <MDBFormInline onSubmit={this.onSubmit} className="md-form">
                                <MDBIcon icon="search" />&nbsp;
                                <input className="form-control form-control-sm w-100"
                                    type="text"
                                    placeholder={this.props.placeholderText}
                                    aria-label="Search"
                                    onKeyUp={this.keyPress}
                                    
                                />
                            </MDBFormInline>


                        </MDBCol>
                    </MDBRow>
                    
                    ) : (
                        <div></div>
                    )}
                {this.props.countryId === 6 ?
                    <MDBRow>
                        <MDBCol md="6" sm="6">
                            <MDBBtn onClick={() => this.props.reloadDispatchOpts()} size="sm" rounded color="secondary">Change Dispatch Type</MDBBtn>
                            <div style={{ marginLeft: "5px", fontSize: "12px", fontWeight: "bold" }} id='helperTextExample' className='form-helper'>
                                (Current Dispatch Option:&nbsp;{this.props.dispatchType === 2 ? this.props.managerChecked? 'Deliver To My Manager' : 'Delivery - ' + this.props.selectedDispatchText : 'Collection - ' + this.props.selectedDispatchText} )
                            </div>
                        </MDBCol>
                </MDBRow> : <div></div>}
                
            </div>
        )
    }
}

export default HeaderShop;